import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { UserGuideNavigation } from "./user-guide/-components/UserGuideNavigation";

export const Route = createFileRoute("/_auth/app/_app/help/user-guide")({
	component: RouteComponent,
});

function RouteComponent() {
	const location = useLocation();

	// Determine active section based on current route
	const getActiveSection = () => {
		const pathname = location.pathname;
		if (
			pathname === "/app/help/user-guide" ||
			pathname === "/app/help/user-guide/"
		) {
			return "overview";
		}
		if (pathname.includes("/organization-setup")) return "organizationSetup";
		if (pathname.includes("/staff-management")) return "staffManagement";
		if (pathname.includes("/customer-management")) return "customerManagement";
		if (pathname.includes("/customer-plans")) return "customerPlans";
		if (pathname.includes("/schedule-management")) return "scheduleManagement";
		if (pathname.includes("/enrollment-process")) return "enrollmentProcess";
		if (pathname.includes("/attendance-tracking")) return "attendanceTracking";
		if (pathname.includes("/payment-processing")) return "paymentProcessing";
		if (pathname.includes("/reports-analytics")) return "reportsAnalytics";
		if (pathname.includes("/system-settings")) return "systemSettings";
		return "overview"; // default
	};

	const activeSection = getActiveSection();

	return (
		<div className="flex flex-col md:flex-row h-full bg-base-200">
			{/* Side Navigation - hidden on mobile */}
			<div className="hidden md:block">
				<UserGuideNavigation activeSection={activeSection} />
			</div>

			{/* Main Content Area - always visible */}
			<div className="flex-1 overflow-auto">
				<Outlet />
			</div>
		</div>
	);
}
